import countries from "i18n-iso-countries";
import { Locale, supportedLocales } from "@ct-react/locale";

export const allLocales = supportedLocales;

const reloadCountries = async (locale: Locale): Promise<void> => {
  if (!countries.langs().includes(locale.basename))
    countries.registerLocale(await import(`i18n-iso-countries/langs/${locale.basename}.json`));
  return new Promise(resolve => resolve(void 0));
}

export const handleLocaleChange = async (locale: Locale): Promise<void> => reloadCountries(locale);
